import React, { PureComponent } from 'react';
import { RRRFetch } from '@cuemath/rest-api';
import TagManager from 'react-gtm-module';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { GTM_KEY } from 'constants/keys';
import { ThemeProvider } from 'styled-components';
import { CuemathAVProvider } from '@cuemath/av';

import THEME from 'constants/theme';
import Routes from './router';
import { getStore } from './store';
import './font.css';
import './app.css';

const store = getStore();

export default class App extends PureComponent {
  componentDidMount() {
    store.subscribe(() => {
      const {
        auth: { accessToken },
      } = store.getState();

      RRRFetch.setHeaders({
        'app-type': 'ONE_APP',
        'user-type': 'student',
        ...(accessToken
          ? {
              'access-token': accessToken,
            }
          : {}),
      });
    });
    /**
     * * TagManager provided by GTM ( Google Tag Manager ) is used to integrate third party analytics without actually writing any code locally .
     *
     * -> WebEngage in our case.
     * -> GMT_KEY is unique for a TAG, This is what controls where we want to log our events or data.
     *
     * * Reference
     * -> https://www.notion.so/cuemath/Resources-c84c31bcecd347638670394436518c42#46ff3258c54c40b0bf144e1c69de0f64
     */

    TagManager.initialize({
      gtmId: GTM_KEY,
    });
  }

  render() {
    return (
      <BrowserRouter>
        <Provider store={store}>
          <ThemeProvider theme={THEME}>
            <CuemathAVProvider>
              <Routes />
            </CuemathAVProvider>
          </ThemeProvider>
        </Provider>
      </BrowserRouter>
    );
  }
}
